import { Box, CircularProgress, Switch, Typography } from "@material-ui/core"
import React, { useEffect, useState } from "react"
import SideBox from "../.."
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { useDispatch } from "react-redux"
import { updateNotifications } from "actions/organization"
import { openSnackBar } from "actions/snack-bar"

const Notifications = ({
  classes,
  isAdminNotified,
  isModeratorNotified,
  orgId
}) => {
  const dispatch = useDispatch()
  const [adminSwitch, setAdminSwitch] = useState(false)
  const [moderatorSwitch, setModeratorSwitch] = useState(false)
  const [adminSwitchLoading, setAdminSwitchLoading] = useState(false)
  const [moderatorSwitchLoading, setModeratorSwitchLoading] = useState(false)

  useEffect(() => {
    setAdminSwitch(isAdminNotified)
    setModeratorSwitch(isModeratorNotified)
  }, [isModeratorNotified])

  const receiveNotification = type => {
    if (type === "admin") {
      setAdminSwitchLoading(true)
    } else {
      setModeratorSwitchLoading(true)
    }
    dispatch(
      updateNotifications(
        type === "admin"
          ? { isNotified: adminSwitch ? false : true, userType: type }
          : { isNotified: moderatorSwitch ? false : true, userType: type },
        orgId
      )
    )
      .then(res => {
        dispatch(openSnackBar({ message: "Notifications Updated" }))
        if (type === "admin") {
          setAdminSwitch(!adminSwitch)
        } else {
          setModeratorSwitch(!moderatorSwitch)
        }
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "error" }))
      })
      .finally(() => {
        if (type === "admin") {
          setAdminSwitchLoading(false)
        } else {
          setModeratorSwitchLoading(false)
        }
      })
  }

  return (
    <SideBox
      title="Post Notifications"
      content={
        <Box className={classes.notificationsContainer}>
          <Box display="flex" alignItems="center">
            <Box style={{ width: "50%" }}>
              <Typography variant="h5" className={classes.titles}>
                Admins
              </Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <Switch
                color="primary"
                disabled={adminSwitchLoading}
                checked={adminSwitch}
                onChange={e => {
                  receiveNotification("admin")
                }}
              />
              {adminSwitchLoading && <CircularProgress size={10} />}
            </Box>
          </Box>
          <Box display="flex">
            <Box style={{ width: "50%" }}>
              <Typography variant="h5" className={classes.titles}>
                Moderators
              </Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <Switch
                color="primary"
                disabled={moderatorSwitchLoading}
                checked={moderatorSwitch}
                onChange={e => {
                  receiveNotification("moderator")
                }}
              />
              {moderatorSwitchLoading && <CircularProgress size={10} />}
            </Box>
          </Box>
        </Box>
      }
    />
  )
}

export default withStyles(styles)(Notifications)



// WEBPACK FOOTER //
// ./src/components/SideBox/components/Notifications/indes.jsx